import ButtonGroupContainer from '../../Componant/Buttons/ButtonGroup'

const ButtonGroup = () => {
  return (
    <div className="page-body">
        <ButtonGroupContainer/>
    </div>
  )
}

export default ButtonGroup